<template>
  <div style="height: 100%">
    <div id="carLeft">
      <group-tree isMore @groups="reGroups" @group="reGroup" :filterGroup='filterGroup'></group-tree>
    </div>
    <div id="carRight">
      <Input
        v-model="keyword"
        placeholder="搜索人员"
        @on-search="getCarList([])"
        search
        style="margin-bottom: 10px"
      />
      <div
        v-if="isMore"
        v-show="checkboxData.length > 0"
        style="margin-top: 4px; margin-bottom: 10px"
      >
        <Checkbox
          :indeterminate="indeterminate"
          :value="checkAll"
          @click.prevent.native="handleCheckAll"
          >全选</Checkbox
        >
      </div>
      <div id="carList" class="gundongtiao">
        <CheckboxGroup
          v-model="checkAllGroup"
          @on-change="checkAllGroupChange"
          v-if="isMore"
        >
          <li v-for="(item, index) in checkboxData" :key="index">
            <Checkbox
              style="width: 100%; text-overflow: ellipsis; white-space: nowrap"
              :label="item.id"
              >{{ item.name }}</Checkbox
            >
          </li>
        </CheckboxGroup>
        <ul v-else>
          <li
            v-for="(item, index) in checkboxData"
            :key="index"
            @click="clickLi(item)"
          >
            {{ item.name }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import groupTree from "./groupTree.vue";
import axios from "axios";
var checkAllGroup = [];
export default {
  props: ["isMore","filterGroup"],
  components: { groupTree },
  data() {
    return {
      indeterminate: false,
      checkAll: false,
      checkAllGroup: [],
      checkboxData: [],
      groupIdList: [],
      groupId:[],
      keyword: "",
    };
  },
  methods: {
    reGroup(y, v) {
      this.reGroups(v);
    },
    reGroups(v) {
      this.groupIdList = [];
      for (const i in v) {
        this.groupIdList.push(v[i].id);
      }
      if (this.groupIdList.length == 0 && this.groupId.length > 0) {
        this.getCarList(this.groupId);
      } else {
        this.getCarList(this.groupIdList);
      }
    },
    getCarList(list) {
      if (list.length == 0 && this.keyword.length == 0) {
        checkAllGroup = [];
        this.checkboxData = [];
        return;
      }
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.dm + "/driver/list",
        data: {
          groupIdList: list,
          keyword: this.keyword,
        },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data.dataList;
        console.log(data);
        this.checkboxData = data;
        checkAllGroup = [];
        for (const i in data) {
          checkAllGroup.push(data[i].id);
        }
      });
    },
    checkAllGroupChange(data) {
      if (data.length === checkAllGroup.length) {
        this.indeterminate = false;
        this.checkAll = true;
      } else if (data.length > 0) {
        this.indeterminate = true;
        this.checkAll = false;
      } else {
        this.indeterminate = false;
        this.checkAll = false;
      }
      this.getNodes();
    },
    handleCheckAll() {
      if (this.indeterminate) {
        this.checkAll = false;
      } else {
        this.checkAll = !this.checkAll;
      }
      this.indeterminate = false;
      if (this.checkAll) {
        this.checkAllGroup = checkAllGroup;
      } else {
        this.checkAllGroup = [];
      }
      this.getNodes();
    },
    //获取选中数据
    getNodes() {
      var carFilder = this.carFilder(this.checkboxData, this.checkAllGroup); //获取选中的车狼。不仅仅是id
      this.$emit("persons", carFilder); //carFilder--选中车辆对象数组
    },
    //根据选中的id去找到对应点的属性
    carFilder(arr1, arr2) {
      return arr1.filter(
        (ele) => arr2.filter((x) => x === ele.id).length > 0
      );
    },
    clickLi(row) {
      this.$emit("person", row);
    },
  },
  mounted() {},
  watch: {
    keyword(v) {
      if (v.length == 0) {
        this.getCarList([]);
      }
    },
  },
};
</script>
<style lang="">
#carLeft,
#carRight {
  width: 50%;
  height: 100%;
  float: left;
}
#carRight {
  padding-left: 10px;
  border-left: solid 1px #ccc;
}
#carRight li:hover {
  background: #ebf8fc;
  cursor: pointer;
}
#carRight li .dasimg {
  vertical-align: middle;
  height: 28px;
  margin-right: 4px;
}
#carList li{
  padding: 2px 4px;
}
#carList{
  height: calc(100% - 80px);
}
</style>


// WEBPACK FOOTER //
// src/components/common/driverTool.vue